import { Add, Save } from '@mui/icons-material';
import { Box, CircularProgress, Grid, IconButton, Typography } from '@mui/material';
import { OptionBox } from './components';
import { SifOption } from '../../types';
import { ObjectProperty } from 'views/backoffice/CustomObjects/types';
import { useState } from 'react';

export type ObjectPanelProps = {
    selectedRow: Record<string, any> | undefined;
    handleChangeOption: (option: SifOption) => void;
    handleDeleteOption: (optionId: number) => void;
    handleAddOption: () => void;
    properties: ObjectProperty[];
    fieldName?: string;
    onSave?: () => Promise<void>;
};

export const ObjectPanel = ({
    selectedRow,
    handleChangeOption,
    handleDeleteOption,
    handleAddOption,
    properties,
    fieldName = 'options',
    onSave
}: ObjectPanelProps) => {
    const [isSaving, setIsSaving] = useState(false);
    const handleSave = async () => {
        setIsSaving(true);
        await onSave?.();
        setIsSaving(false);
    };
    return (
        <Grid item xs="auto" height="100%">
            <Grid
                container
                flexDirection="column"
                gap="18px"
                width="350px"
                bgcolor="#fff"
                height="100%"
                p="12px"
                borderRadius="12px"
                flexWrap="nowrap"
            >
                <Grid container item justifyContent="space-between" alignItems="center">
                    <Grid item xs>
                        <Typography color="#37326E" fontWeight={700} fontSize="16px">
                            Options
                        </Typography>
                    </Grid>
                    <Grid item container spacing={2} xs="auto" alignItems="center">
                        {onSave && (
                            <Grid item xs="auto">
                                <IconButton onClick={handleSave} disabled={isSaving || !selectedRow?.[fieldName]?.length}>
                                    {isSaving ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        <Save
                                            sx={{
                                                bgcolor: '#f5f6f7',
                                                borderRadius: '100%',
                                                fontSize: '25px',
                                                color: '#858585',
                                                cursor: 'pointer'
                                            }}
                                        />
                                    )}
                                </IconButton>
                            </Grid>
                        )}
                        <Grid item xs="auto">
                            <IconButton onClick={handleAddOption} disabled={isSaving}>
                                <Add
                                    sx={{
                                        bgcolor: '#f5f6f7',
                                        borderRadius: '100%',
                                        fontSize: '30px',
                                        color: '#858585',
                                        cursor: 'pointer'
                                    }}
                                />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
                <Box sx={{ color: '#858585', overflow: 'scroll', display: 'flex', flexDirection: 'column', gap: '16px', pr: '12px' }}>
                    {selectedRow?.[fieldName]?.map((option: SifOption) => (
                        <OptionBox
                            key={option.tempId}
                            option={option}
                            handleChangeOption={handleChangeOption}
                            handleDeleteOption={handleDeleteOption}
                            properties={properties}
                        />
                    ))}
                </Box>
            </Grid>
        </Grid>
    );
};
